enum CardsOrderStatusDisplayOrderType {
  NEW_CARD = 'NEW_CARD',
  RENEWED_CARD = 'RENEWED_CARD',
}

export default CardsOrderStatusDisplayOrderType;
